import React, { useCallback } from 'react';
import './MobileControls.css';
import { useMobileDetection } from '../../hooks/useMobileDetection';

const MobileControls = ({ movementSystem }) => {
  const { isMobile } = useMobileDetection();

  const handleTouchStart = useCallback((direction) => {
    if (!movementSystem) return;
    
    // Use the proper method to set movement state
    if (movementSystem.setMovementState) {
      movementSystem.setMovementState(direction, true);
    } else {
      // Fallback for direct property access
      switch(direction) {
        case 'forward':
          movementSystem.moveForward = true;
          break;
        case 'backward':
          movementSystem.moveBackward = true;
          break;
        case 'left':
          movementSystem.moveLeft = true;
          break;
        case 'right':
          movementSystem.moveRight = true;
          break;
      }
    }
  }, [movementSystem]);

  const handleTouchEnd = useCallback((direction) => {
    if (!movementSystem) return;
    
    // Use the proper method to set movement state
    if (movementSystem.setMovementState) {
      movementSystem.setMovementState(direction, false);
    } else {
      // Fallback for direct property access
      switch(direction) {
        case 'forward':
          movementSystem.moveForward = false;
          break;
        case 'backward':
          movementSystem.moveBackward = false;
          break;
        case 'left':
          movementSystem.moveLeft = false;
          break;
        case 'right':
          movementSystem.moveRight = false;
          break;
      }
    }
  }, [movementSystem]);

  // Also handle mouse events for testing on desktop
  const handleMouseDown = useCallback((direction) => {
    handleTouchStart(direction);
  }, [handleTouchStart]);

  const handleMouseUp = useCallback((direction) => {
    handleTouchEnd(direction);
  }, [handleTouchEnd]);

  // Hide arrow keys on mobile - joystick replaces them
  if (!movementSystem) return null;
  
  // Don't show arrow keys on mobile since we have joystick
  if (isMobile) return null;

  return (
    <div className="mobile-controls">
      <button 
        onTouchStart={() => handleTouchStart('forward')}
        onTouchEnd={() => handleTouchEnd('forward')}
        onMouseDown={() => handleMouseDown('forward')}
        onMouseUp={() => handleMouseUp('forward')}
        onMouseLeave={() => handleMouseUp('forward')}
        className="control-button forward"
      >
        ↑
      </button>
      <button 
        onTouchStart={() => handleTouchStart('backward')}
        onTouchEnd={() => handleTouchEnd('backward')}
        onMouseDown={() => handleMouseDown('backward')}
        onMouseUp={() => handleMouseUp('backward')}
        onMouseLeave={() => handleMouseUp('backward')}
        className="control-button backward"
      >
        ↓
      </button>
      <button 
        onTouchStart={() => handleTouchStart('left')}
        onTouchEnd={() => handleTouchEnd('left')}
        onMouseDown={() => handleMouseDown('left')}
        onMouseUp={() => handleMouseUp('left')}
        onMouseLeave={() => handleMouseUp('left')}
        className="control-button left"
      >
        ←
      </button>
      <button 
        onTouchStart={() => handleTouchStart('right')}
        onTouchEnd={() => handleTouchEnd('right')}
        onMouseDown={() => handleMouseDown('right')}
        onMouseUp={() => handleMouseUp('right')}
        onMouseLeave={() => handleMouseUp('right')}
        className="control-button right"
      >
        →
      </button>
    </div>
  );
};

export default MobileControls; 